var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 68,
    viewBox: "0 0 64 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.298523 30.5845C0.298523 29.2761 0.86333 28.0314 1.84799 27.1699L29.1614 3.27061C30.8721 1.77376 33.4264 1.77376 35.1371 3.27061L62.4505 27.1699C63.4352 28.0314 64 29.2761 64 30.5845V62.8064C64 65.3123 61.9686 67.3438 59.4627 67.3438H4.83584C2.32995 67.3438 0.298523 65.3123 0.298523 62.8064V30.5845Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8873 2.15552C32.8649 2.21181 33.828 2.58351 34.6132 3.27062L61.9267 27.1699C62.9113 28.0315 63.4761 29.2762 63.4761 30.5845V62.8064C63.4761 65.3123 61.4447 67.3438 58.9388 67.3438H31.8873V2.15552Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8873 2.15552C32.8649 2.21181 33.828 2.58351 34.6132 3.27062L61.9267 27.1699C62.9113 28.0315 63.4761 29.2762 63.4761 30.5845V62.8064C63.4761 65.3123 61.4447 67.3438 58.9388 67.3438H31.8873V2.15552Z",
    fill: "url(#paint2_linear)",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 32.1493,
    y1: 0.65625,
    x2: 32.1493,
    y2: 92.9782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197DD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 31.6254,
    y1: -0.51256,
    x2: 31.6254,
    y2: 93.4276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197DD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 47.6817,
    y1: 2.15552,
    x2: 47.6817,
    y2: 67.3438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.06eb30a4.svg";
export { ForwardRef as ReactComponent };